import React from 'react';
import PropTypes from 'prop-types';
import StatusOverview from './StatusOverview';
import PlannedIncidents from './PlannedIncidents';
import Legend from '../legend/Legend';
import GroupsWrapper from '../groupsWrapper/GroupsWrapper';

import './frontpage-components.css';

const FrontpageComponents = ({ maintenances, groups, includedComponents, incidents }) => {
  return (
    <>
      <PlannedIncidents maintenances={maintenances} includedComponents={includedComponents} />
      
      <div className="dnb-services-section">
        <h2 className='dnb-services-section__heading'>Services</h2>
        <Legend />
        <GroupsWrapper groups={groups} incidents={incidents} />
      </div>
    </>
  );
};

FrontpageComponents.propTypes = {
  maintenances: PropTypes.array,
  groups: PropTypes.array,
  includedComponents: PropTypes.object,
  incidents: PropTypes.array
};

export default FrontpageComponents;
